import React, { memo } from 'react'
import { Box, Typography } from '@mui/material'
import Icon from '../../../../../../components/icon'

const RecordingRetentionWarning = memo(({ days = 60 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        px: '12px',
        py: '7px',
        mb: '4px',
        background:
          'linear-gradient(90deg, rgba(255,152,0,0.13) 0%, rgba(255,193,7,0.08) 100%)'
      }}
    >
      <Icon
        icon="mdi:clock-alert-outline"
        style={{
          fontSize: '16px',
          color: 'var(--warning-main)',
          flexShrink: 0
        }}
      />
      <Typography
        sx={{
          fontSize: '12px',
          color: 'var(--warning-dark, #e65100)',
          fontWeight: 500,
          lineHeight: 1.4,
          flex: 1
        }}
      >
        <Typography component="span" sx={{ fontWeight: 700, fontSize: '12px' }}>
          Recording Retention Notice:&nbsp;
        </Typography>
        All candidate video recordings, gaze cluster images, and auxiliary
        device evidence are deleted because they are older than{' '}
        <Typography component="span" sx={{ fontWeight: 700, fontSize: '12px' }}>
          {days} days.
        </Typography>
      </Typography>
    </Box>
  )
})

export default RecordingRetentionWarning
